'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISTANCE_FROM_TOOLTIP_MARKER = 35;

var TooltipTextBubble = function (_PureComponent) {
    _inherits(TooltipTextBubble, _PureComponent);

    function TooltipTextBubble() {
        _classCallCheck(this, TooltipTextBubble);

        var _this = _possibleConstructorReturn(this, (TooltipTextBubble.__proto__ || Object.getPrototypeOf(TooltipTextBubble)).apply(this, arguments));

        _this.state = { show: false, position: { x: null, y: null } };
        _this.dimensions = { width: 0, height: 0 };
        _this.onContainerRef = function (ref) {
            _this.containerNode = ref;
        };
        return _this;
    }

    _createClass(TooltipTextBubble, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.componentRef(this);

            var _containerNode$getBou = this.containerNode.getBoundingClientRect(),
                width = _containerNode$getBou.width,
                height = _containerNode$getBou.height;

            this.dimensions = { width: width, height: height };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                verticalAlignment = _props.verticalAlignment,
                horizontalAlignment = _props.horizontalAlignment,
                backgroundColor = _props.backgroundColor,
                arrowClassName = _props.arrowClassName,
                contentClassName = _props.contentClassName,
                className = _props.className,
                arrowHeight = _props.arrowHeight,
                arrowWidth = _props.arrowWidth,
                borderColor = _props.borderColor;
            var _state = this.state,
                position = _state.position,
                show = _state.show;

            var classNames = 'luna-tooltip ' + (show ? 'is-active' : '');
            var bubblePosition = this.calculateBubblePosition(position, {
                verticalAlignment: verticalAlignment,
                horizontalAlignment: horizontalAlignment
            });
            var arrowPosition = this.calculateArrowPosition(bubblePosition, {
                verticalAlignment: verticalAlignment,
                horizontalAlignment: horizontalAlignment
            });
            return _react2.default.createElement("div", { ref: this.onContainerRef, className: classNames + ' ' + className, style: {
                    backgroundColor: backgroundColor,
                    borderColor: borderColor || backgroundColor,
                    top: bubblePosition.y,
                    left: bubblePosition.x
                } }, _react2.default.createElement(_styles.Arrow, { className: 'luna-tooltipArrow ' + arrowClassName, verticalAlignment: verticalAlignment, horizontalAlignment: horizontalAlignment, arrowPosition: arrowPosition, borderColor: borderColor, backgroundColor: backgroundColor, height: arrowHeight, width: arrowWidth }), _react2.default.createElement("span", { className: contentClassName }, this.props.children));
        }
    }, {
        key: 'calculateBubblePosition',
        value: function calculateBubblePosition(iconPosition, _ref) {
            var verticalAlignment = _ref.verticalAlignment,
                horizontalAlignment = _ref.horizontalAlignment;

            if (!this.containerNode) {
                return { x: 0, y: 0 };
            }
            var dimensions = this.containerNode.getBoundingClientRect();
            var alignmentCoefficient = horizontalAlignment === 'left' ? 1 : 0;
            var verticalCoefficient = verticalAlignment === 'bottom' ? 1 : -0.5; // in all honesty, no clue why the -0.5...
            var contentCoefficient = verticalAlignment === 'top' ? -1 : 0;
            return {
                x: iconPosition.x - dimensions.width * 0.8 * alignmentCoefficient,
                y: iconPosition.y + verticalCoefficient * DISTANCE_FROM_TOOLTIP_MARKER + contentCoefficient * dimensions.height
            };
        }
    }, {
        key: 'calculateArrowPosition',
        value: function calculateArrowPosition(bubblePosition, _ref2) {
            var horizontalAlignment = _ref2.horizontalAlignment,
                verticalAlignment = _ref2.verticalAlignment;

            if (!this.containerNode) {
                return { x: 0, y: 0 };
            }
            var dimensions = this.containerNode.getBoundingClientRect();
            var verticalCoefficient = verticalAlignment === 'top' ? 1 : 0;
            var alignmentCoefficient = horizontalAlignment === 'left' ? 1 : 0;
            return {
                x: bubblePosition.x + this.props.arrowWidth + dimensions.width * 0.8 * alignmentCoefficient,
                y: bubblePosition.y + verticalCoefficient * dimensions.height - this.props.arrowHeight / 2 + 1 - 2 * verticalCoefficient
            };
        }
    }]);

    return TooltipTextBubble;
}(_react.PureComponent);

exports.default = TooltipTextBubble;

TooltipTextBubble.propTypes = {
    arrowWidth: _propTypes2.default.number,
    arrowHeight: _propTypes2.default.number,
    verticalAlignment: _propTypes2.default.oneOf(['top', 'bottom']),
    horizontalAlignment: _propTypes2.default.oneOf(['left', 'right']),
    backgroundColor: _propTypes2.default.string,
    arrowClassName: _propTypes2.default.string,
    contentClassName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    componentRef: _propTypes2.default.func.isRequired
};
TooltipTextBubble.defaultProps = {
    arrowHeight: 12,
    arrowWidth: 12,
    borderColor: '',
    verticalAlignment: 'bottom',
    horizontalAlignment: 'right',
    backgroundColor: '#5ab1fe',
    className: '',
    arrowClassName: '',
    contentClassName: undefined
};
//# sourceMappingURL=TextBubble.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tooltip/TextBubble.js